<template>
  <v-dialog
    scrollable
    max-width="650"
    v-model="show"
    @click:outside="$emit('hide')"
    @keydown.esc="$emit('hide')"
  >
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>

      <v-card-text class="mb-0 pb-0">
        <slot />
      </v-card-text>
      <v-card-actions class="justify-end">
        <slot name="modal-footer" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: function() {
    return {
      show: true,
    }
  },
  props: {
    title: {
      type: String,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    backdrop: {
      type: Boolean,
      default: true,
    },
    canClose: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
    },
  },
  methods: {
    onHide: function(reason) {
      if (reason === 'dismiss' || reason === 'cancel') {
        return this.$emit('hide')
      }

      this.show = true
    },
  },
}
</script>
